// src/components/common/LinkifiedText.tsx

'use client'

import type { ReactNode } from 'react'

export function LinkifiedText({
  text,
  className,
}: {
  text: string
  className?: string
}) {
  const urlRegex =
    /(?:https?:\/\/|www\.)[^\s<]+|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s<]*)?/gi

  const nodes: ReactNode[] = []

  let lastIndex = 0

  for (const match of String(text || '').matchAll(urlRegex)) {
    const rawUrl = match[0]
    const index = match.index ?? 0

    if (index > lastIndex) {
      nodes.push(text.slice(lastIndex, index))
    }

    const cleanUrl = rawUrl.replace(/[.,!?;:)]+$/, '')
    const trailing = rawUrl.slice(cleanUrl.length)

    const href =
      cleanUrl.startsWith('http://') ||
      cleanUrl.startsWith('https://')
        ? cleanUrl
        : `https://${cleanUrl}`

    nodes.push(
      <a
        key={`${cleanUrl}-${index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={
          className ??
          'font-medium text-primary underline-offset-4 hover:underline'
        }
        onClick={(e) => e.stopPropagation()}
      >
        {cleanUrl}
      </a>
    )

    if (trailing) {
      nodes.push(trailing)
    }

    lastIndex = index + rawUrl.length
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex))
  }

  return <>{nodes}</>
}